module.exports = __webpack_public_path__ + "static/media/t5.af2053f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Hotel/components/Documentation/images/t5.jpg
// module id = 406
// module chunks = 0